import { getLayout as getMaxWidthContainerLayout } from 'layouts/MaxWidthContainerLayout';
import { getLayout as getSiteOuterLayout } from 'layouts/SiteOuterLayout';
import { PageLayoutProps } from 'lib/shared/types/PageLayout';

export const ArticlesIndexLayout = ({ children }: PageLayoutProps) => children;

export const getLayout = (page) =>
  getSiteOuterLayout(
    getMaxWidthContainerLayout(
      <ArticlesIndexLayout>{page}</ArticlesIndexLayout>
    )
  );

ArticlesIndexLayout.getLayout = getLayout;
